import styled, {css} from 'styled-components/native';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import {Dimensions} from 'react-native';
import {getBottomSpace, isIphoneX} from 'react-native-iphone-screen-helper';

import Feather from 'react-native-vector-icons/Feather';

import { ImageBackground } from 'react-native';

interface StepCircleStyle {
  status: 'editing' | 'done' | 'pending';
}

interface StepLineStyle {
  active: boolean;
  width?: string;
}

interface StepTextStyle {
  active: boolean;
  width?: number;
}

interface Check {
  checked?: boolean;
}

interface FormStyle {
  height?: number;
}

export const Form = styled.ScrollView<FormStyle>`
  padding: ${RFValue(18)}px;

  max-height: ${Dimensions.get('window').height}px;
`;

export const FormHeader = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
    margin-bottom: ${RFValue(20)}px;
`;

export const IconHeader = styled(Feather)`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(22)}px;
`;

export const FormInfos = styled.View``;

export const IconButton = styled.TouchableOpacity`
  height: ${RFValue(24)}px;
  width: ${RFValue(24)}px;

`;

export const FormStep = styled.View``;

export const Title = styled.Text`
  font-size: ${RFValue(16)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};
`;

export const Subtitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;

`;

export const Step = styled.View`
  width: 100%;
  flex-direction: row;
  align-items: center;
  padding-bottom: ${RFValue(30)}px;
`;



export const LineStep = styled.View<StepLineStyle>`
  height: 4px;
  flex-grow: 1;
  margin: 0 4px;
  border-radius: 12px;
  ${({active}) =>
    css`
      background-color: ${({theme}) =>
        active ? theme.colors.primary : theme.colors.placeholder};
    `}
`;

export const LineStepSeparator = styled(LineStep)`
  width: 40px;
  flex-grow: 0;
`;

export const CircleStep = styled.View<StepCircleStyle>`
  height: 24px;
  width: 24px;
  border-radius: 12px;
  position: relative;
  ${({status, theme}) =>
    status === 'done' &&
    css`
      border-color: ${theme.colors.primary};
      border-width: 4px;
      background-color: ${theme.colors.primary};
    `}

  ${({status, theme}) =>
    status === 'editing' &&
    css`
      border-color: ${theme.colors.primary};
      border-width: 4px;
    `}

  ${({status, theme}) =>
    status === 'pending' &&
    css`
      border-color: ${theme.colors.placeholder};
      border-width: 4px;
    `}
`;

export const StepText = styled.Text<StepTextStyle>`
  position: absolute;
  right: 0;
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(9)}px;

  ${({active, width = 100, theme}) =>
    css`
      width: ${width}px;
      left: -${width / 2 - 12}px;
      top: 24px;
      color: ${active ? theme.colors.primary : theme.colors.placeholder};
    `};
`;

export const FormControl = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const Label = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.medium};
`;

export const PromoLabel = styled.Text`
  font-size: ${RFValue(12)}px;
  flex:1;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.medium};
`;

export const TermContainer = styled.View`
  flex-direction: row;
  align-items: center;

  justify-content: space-between;
  margin-top: ${RFValue(12)}px;
`;

export const TermLinkButton = styled.TouchableOpacity`
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.blue};
  border-style: solid;
  
`;

export const TermLinkText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  
  color: ${({theme}) => theme.colors.blue};
`;

export const TermCheckButton = styled.TouchableOpacity`
  flex-direction: row;
  align-items:center;
  gap: ${RFValue(6)}px;
`;

export const TermContainerBox = styled.View`
  flex-direction: column;
`;

export const TermCheckIcon = styled(FontAwesome)<Check>`
  font-size: ${RFValue(20)}px;
  color: ${({theme}) => theme.colors.text};
  ${({checked, theme}) =>
    checked &&
    css`
      color: ${theme.colors.blue};
    `}
`;

export const PromosContainer = styled.View`
  flex-direction: row;
  align-items: flex-start;

  justify-content: space-between;

`;

export const PromoLinkButton = styled.TouchableOpacity`
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.blue};
  border-style: solid;
  
`;

export const PromoLinkText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  
  color: ${({theme}) => theme.colors.blue};
`;

export const PromoCheckButton = styled.TouchableOpacity`
  flex-direction: row;
  align-items:flex-start;
  gap: ${RFValue(6)}px;
  
`;

export const PromoCheckIcon = styled(FontAwesome)<Check>`
  font-size: ${RFValue(20)}px;
  color: ${({theme}) => theme.colors.text};
  margin-top: ${RFValue(2)}px;
  ${({checked, theme}) =>
    checked &&
    css`
      color: ${theme.colors.blue};
    `}
`;

export const OutlineButton = styled.TouchableOpacity`
  padding: ${RFValue(2)}px 0;
  border-bottom-width: 2px;
  border-style: solid;
  border-color: ${({theme}) => theme.colors.blue};
`;

export const OutlineButtonText = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.blue};
`;

export const OutlineButtonContainer = styled.View`
  flex-direction: row;
`;

export const BackgroundContainer = styled.View<FormStyle>`
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;

  overflow: hidden;
  height: ${isIphoneX() ? RFPercentage(34) : RFPercentage(34)}px;
`;

//@ts-ignore
export const Background = styled(ImageBackground)<FormStyle>`
  height: ${RFValue(60)}px;
  background-color: #000;
  justify-content: center;
`;

export const BackgroundHeader = styled.View`
  padding: 20px;
  padding-bottom: 0;
  flex-direction: row;
`;

export const Content = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  flex: 1;
  padding: 20px;
  padding-bottom: 0;
  z-index: 2;
`;

export const Footer = styled.View`
  padding: ${getBottomSpace()}px 20px;
  padding-top: ${RFValue(12)}px;
`;

export const Separator = styled.View`
  margin-bottom: ${RFValue(6)}px;
`;

export const SignupRow = styled.View`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: ${RFValue(4)}px;
  margin-top: ${RFValue(12)}px;
`;

export const SignupText = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
`;

export const SignupLink = styled.TouchableOpacity``;

export const SignupLinkText = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.blue};
  text-decoration-line: underline;
`;
